import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Instagram, Linkedin } from 'lucide-react';
import { LOCAL_SEO_CITIES } from '../data/localSeo';
import { WA_URL } from '../lib/utils';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_talent-match-304/artifacts/w2pnjd4z_4F63405D-91D9-42AD-A592-65AF89FFF01A.png';

const Footer = () => {
  return (
    <footer className="hm-gradient-footer text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(circle at 80% 20%, white 1px, transparent 1px)', backgroundSize: '40px 40px' }} />
      <div className="container-hm px-6 py-16 grid md:grid-cols-2 lg:grid-cols-5 gap-10 relative">
        <div className="lg:col-span-1">
          <div className="bg-white rounded-2xl p-3 inline-block shadow-md">
            <img src={LOGO_URL} alt="HM Talent" className="h-14 w-auto" />
          </div>
          <p className="mt-5 text-sm leading-relaxed text-white/95">Recrutamento ágil e assertivo. Conectamos empresas e profissionais com agilidade, transparência e qualidade.</p>
          <div className="flex gap-3 mt-5">
            <a href="https://instagram.com/hmtalentrh" target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-instagram-link" className="w-9 h-9 rounded-full bg-white/20 hover:bg-white hover:text-hm-orange flex items-center justify-center transition-colors"><Instagram className="w-4 h-4" /></a>
            <a href="https://www.linkedin.com/in/higormonteiroh/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="w-9 h-9 rounded-full bg-white/20 hover:bg-white hover:text-hm-orange flex items-center justify-center transition-colors"><Linkedin className="w-4 h-4" /></a>
          </div>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 text-lg">Navegação</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/" className="text-white/95 hover:text-white hover:underline transition-colors">Início</Link></li>
            <li><Link to="/sobre-nos" className="text-white/95 hover:text-white hover:underline transition-colors">Sobre Nós</Link></li>
            <li><Link to="/para-empresas" className="text-white/95 hover:text-white hover:underline transition-colors">Para Empresas</Link></li>
            <li><Link to="/para-candidatos" className="text-white/95 hover:text-white hover:underline transition-colors">Para Candidatos</Link></li>
            <li><Link to="/contato" className="text-white/95 hover:text-white hover:underline transition-colors">Contato</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 text-lg">Portais</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/portal/candidato/login" data-testid="footer-portal-candidato" className="text-white/95 hover:text-white hover:underline transition-colors">Portal do Candidato</Link></li>
            <li><Link to="/portal/empresa/login" data-testid="footer-portal-empresa" className="text-white/95 hover:text-white hover:underline transition-colors">Portal da Empresa</Link></li>
            <li><Link to="/para-candidatos" className="text-white/95 hover:text-white hover:underline transition-colors">Vagas em aberto</Link></li>
            <li><Link to="/portal/candidato/cadastro" className="text-white/95 hover:text-white hover:underline transition-colors">Cadastrar currículo</Link></li>
            <li><Link to="/portal/admin/login" data-testid="footer-portal-admin" className="text-white/70 hover:text-white hover:underline transition-colors">Portal Administrativo</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 text-lg">Contato</h4>
          <ul className="space-y-3 text-sm">
            <li><a href={WA_URL()} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="flex items-start gap-2 text-white/95 hover:text-white hover:underline"><Phone className="w-4 h-4 mt-0.5 shrink-0" /> (11) 92089-7014</a></li>
            <li><a href="mailto:higor@hmtalent.com.br" data-testid="footer-email-link" className="flex items-start gap-2 text-white/95 hover:text-white hover:underline"><Mail className="w-4 h-4 mt-0.5 shrink-0" /> higor@hmtalent.com.br</a></li>
            <li className="flex items-start gap-2 text-white/95"><MapPin className="w-4 h-4 mt-0.5 shrink-0" /> Mauá - SP | Atendimento em todo o território nacional</li>
          </ul>
        </div>

        <div className="md:col-span-2 lg:col-span-1">
          <h4 className="text-white font-bold mb-4 text-lg">Recrutamento no ABC</h4>
          <ul className="grid grid-cols-2 lg:grid-cols-1 gap-x-4 gap-y-2.5 text-sm">
            {LOCAL_SEO_CITIES.map((c) => (
              <li key={c.slug}>
                <Link to={`/${c.slug}`} data-testid={`footer-local-${c.slug}`} className="text-white/90 hover:text-white hover:underline transition-colors">{c.shortCity || c.city}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/25 relative">
        <div className="container-hm px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-white/90">
          <span>© {new Date().getFullYear()} HM Talent. Todos os direitos reservados.</span>
          <span>Recrutamento ágil. Assertividade comprovada.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
